var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMolecule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97584 5.38256C7.99178 5.25729 8 5.1296 8 5C8 3.34315 6.65685 2 5 2C3.34315 2 2 3.34315 2 5C2 6.65685 3.34315 8 5 8C5.99257 8 6.87255 7.51797 7.41863 6.77523L12.0242 8.61744C12.0082 8.74271 12 8.8704 12 9C12 9.55636 12.1514 10.0773 12.4154 10.524L8.24822 14.6911C7.60751 14.255 6.83353 14 6 14C3.79086 14 2 15.7909 2 18C2 20.2091 3.79086 22 6 22C8.20914 22 10 20.2091 10 18C10 17.1665 9.74505 16.3925 9.30888 15.7518L13.476 11.5846C13.9227 11.8486 14.4436 12 15 12C15.5564 12 16.0773 11.8486 16.524 11.5846L18.1583 13.2189C18.0564 13.4589 18 13.7229 18 14C18 15.1046 18.8954 16 20 16C21.1046 16 22 15.1046 22 14C22 12.8954 21.1046 12 20 12C19.7229 12 19.4589 12.0564 19.2189 12.1583L17.5846 10.524C17.8486 10.0773 18 9.55636 18 9C18 7.34315 16.6569 6 15 6C14.0074 6 13.1274 6.48203 12.5814 7.22477L7.97584 5.38256Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolecule);
export default __webpack_public_path__ + "static/media/molecule.4b56c4f13542d506715d43154675f0c7.svg";
export { ForwardRef as ReactComponent };